export default "__VITE_ASSET__PfKM3Ttl__";